import React from 'react';
import { animations } from "react-animation";
import AppMenu from '../AppMenu/AppMenu';

function AppBar(props) {
    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-primary" style={{ animation: animations.fadeIn }}>
            <AppMenu/>
        </nav>
    );
}

export default AppBar;